import figmaLogo from "../images/creative-tools-logos/figma-logo.svg";
import photoshopLogo from "../images/creative-tools-logos/photoshop-logo.svg";
import illustratorLogo from "../images/creative-tools-logos/illustrator-logo.svg";
import indesignLogo from "../images/creative-tools-logos/indesign-logo.svg";
import afterEffectsLogo from "../images/creative-tools-logos/after-effects-logo.svg";
import premiereLogo from "../images/creative-tools-logos/premiere-logo.svg";
import miroLogo from "../images/creative-tools-logos/miro-logo.svg";
import { SKILL_ICONS } from "./skillIcons";

const techLogos = [
  { src: figmaLogo, alt: "Figma Logo", name: "Figma" },
  { src: photoshopLogo, alt: "Adobe Photoshop Logo", name: "Photoshop" },
  { src: illustratorLogo, alt: "Adobe Illustrator Logo", name: "Illustrator" },
  { src: indesignLogo, alt: "Adobe InDesign Logo", name: "InDesign" },
  { src: afterEffectsLogo, alt: "After Effects Logo", name: "After Effects" },
  { src: premiereLogo, alt: "Premiere Pro Logo", name: "Premiere Pro" },
  { src: miroLogo, alt: "Miro Logo", name: "Miro" },
  {
    src: SKILL_ICONS.brandStrategy,
    alt: "Brand Strategy Icon",
    name: "Brand Strategy",
  },
  {
    src: SKILL_ICONS.artDirection,
    alt: "Art Direction Icon",
    name: "Art Direction",
  },
  {
    src: SKILL_ICONS.campaignDevelopment,
    alt: "Campaign Development Icon",
    name: "Campaign Development",
  },
  { src: SKILL_ICONS.typography, alt: "Typography Icon", name: "Typography" },
  {
    src: SKILL_ICONS.storytelling,
    alt: "Storytelling Icon",
    name: "Storytelling",
  },
  {
    src: SKILL_ICONS.motionDesign,
    alt: "Motion Design Icon",
    name: "Motion Design",
  },
  {
    src: SKILL_ICONS.clientPresentation,
    alt: "Client Presentation Icon",
    name: "Client Presentation",
  },
  {
    src: SKILL_ICONS.teamLeadership,
    alt: "Team Leadership Icon",
    name: "Team Leadership",
  },
];

export default techLogos;
